import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { clearUserData } from "../../redux/slices/userSlice";
import { clearRegisterData } from "../../redux/slices/registerSlice";
import { showManualContextualLoader } from "../../utils/contextualLoaderTrigger";
import Cookies from "js-cookie";

export default function Logout() {
  const dispatch = useDispatch();

  useEffect(() => {
    showManualContextualLoader("Logging out, please wait...", 3100);

    const allCookies = Cookies.get(); // returns an object with all cookies
    Object.keys(allCookies).forEach((cookieName) => {
      Cookies.remove(cookieName, { path: "/" });
    });

    localStorage.clear();
    dispatch(clearUserData());
    dispatch(clearRegisterData());
    // persistor.pause();
    // persistor.purge();
    // persistor.flush();
    handleRedirect();
  }, [dispatch]);

  const handleRedirect = () => {
    setTimeout(() => {
      window.location.href = "/";
    }, 3 * 1000);
  };

  return (
    <div>
      <img src="/images/logout.svg" style={{ opacity: 0 }} alt="" />
    </div>
  );
}
